const DAYS = [
  { key: "monday", label: "Lun" },
  { key: "tuesday", label: "Mar" },
  { key: "wednesday", label: "Mer" },
  { key: "thursday", label: "Gio" },
  { key: "friday", label: "Ven" },
  { key: "saturday", label: "Sab" },
  { key: "sunday", label: "Dom" },
];

const SLOTS = [
  { index: 0, label: "9-13" },
  { index: 1, label: "13-17" },
  { index: 2, label: "17-21" },
];

export const TimePreferenceGrid = ({ preferences = {}, onChange }) => {
  const toggle = (dayKey, slotIndex) => {
    const current = preferences[dayKey] || [];
    const updated = current.includes(slotIndex)
      ? current.filter((s) => s !== slotIndex)
      : [...current, slotIndex];
    onChange({ ...preferences, [dayKey]: updated });
  };

  // Is the slot enabled on ALL days?
  const isSlotAllSelected = (slotIndex) =>
    DAYS.every((d) => (preferences[d.key] || []).includes(slotIndex));

  // Toggle a slot for ALL days at once: if it's already active on all days → remove from all.
  // Otherwise → add to all days (without touching other slots already selected).
  const toggleSlotAll = (slotIndex) => {
    const allSelected = isSlotAllSelected(slotIndex);
    const next = { ...preferences };
    for (const d of DAYS) {
      const arr = next[d.key] || [];
      if (allSelected) {
        next[d.key] = arr.filter((s) => s !== slotIndex);
      } else if (!arr.includes(slotIndex)) {
        next[d.key] = [...arr, slotIndex];
      } else {
        next[d.key] = arr;
      }
    }
    onChange(next);
  };

  return (
    <div className="mt-2" data-testid="time-preference-grid">
      <div className="grid grid-cols-[auto_repeat(7,1fr)] gap-1.5">
        {/* Header row */}
        <div className="h-8" />
        {DAYS.map((d) => (
          <div key={d.key} className="text-center text-[11px] font-bold uppercase tracking-wide text-slate-500 flex items-center justify-center h-8">
            {d.label}
          </div>
        ))}

        {/* Slot rows */}
        {SLOTS.map((slot) => {
          const allOn = isSlotAllSelected(slot.index);
          return (
            <div key={slot.index} className="contents">
              <button
                type="button"
                data-testid={`pref-row-all-${slot.index}`}
                onClick={() => toggleSlotAll(slot.index)}
                title={allOn ? `Deseleziona ${slot.label} per tutti i giorni` : `Seleziona ${slot.label} per tutti i giorni`}
                className={`text-[11px] font-medium flex items-center justify-end pr-2 h-10 whitespace-nowrap rounded-sm border-2 transition-all duration-150 cursor-pointer ${
                  allOn
                    ? "bg-green-50 border-green-300 text-green-800 font-bold"
                    : "bg-white border-transparent text-slate-600 hover:bg-green-50 hover:border-green-300"
                }`}
              >
                {slot.label}
              </button>
              {DAYS.map((day) => {
                const active = (preferences[day.key] || []).includes(slot.index);
                return (
                  <button
                    key={`${day.key}-${slot.index}`}
                    type="button"
                    data-testid={`pref-${day.key}-${slot.index}`}
                    onClick={() => toggle(day.key, slot.index)}
                    className={`h-10 rounded-sm border-2 transition-all duration-150 ${
                      active
                        ? "bg-green-700 border-green-800 shadow-inner"
                        : "bg-white border-slate-200 hover:border-green-400 hover:bg-green-50"
                    }`}
                    title={`${day.label} ${slot.label}`}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
      <p className="text-[10px] text-slate-400 mt-2 text-center">
        Clicca su <span className="font-bold">9-13</span>, <span className="font-bold">13-17</span> o <span className="font-bold">17-21</span> per applicare quella fascia a tutti i giorni, oppure seleziona giorno per giorno
      </p>
    </div>
  );
};
